import React from "react";
import "../css/LocationDetails.css";

export default function LocationDetails() {
  return (
    <footer className="py-5 text-center position-relative">
      <div className="location-wrapper">
        <a
          href="https://www.google.com/maps/place/ELY+WINE+STORE+MAYNOOTH/@53.3822951,-6.5890017,16z/data=!3m1!4b1!4m6!3m5!1s0x48676fb484cb4f27:0xf8ec45c6dc5cbf89!8m2!3d53.3822951!4d-6.5890017!16s%2Fg%2F11h0vgnmtm?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark text-decoration-none"
        ><p>
          Convent Lane<br />
          Maynooth<br/>
          Co. Kildare <br/>
          W23 C9V9
        </p>
        </a>
        <div className="map-tooltip">
          <iframe
  title="Ely Wine Store Maynooth"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4759.637200801138!2d-6.589001700000001!3d53.3822951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48676fb484cb4f27%3A0xf8ec45c6dc5cbf89!2sELY%20WINE%20STORE%20MAYNOOTH!5e0!3m2!1sen!2sie!4v1758337646971!5m2!1sen!2sie"
  width={250}
  height={200}
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

        </div>
      </div>

      <p>
        <a href="tel:(01) 504 3709" className="text-dark">
          <p> +353 1 5043709 </p>
        </a>
      </p>
      <p className="fw-bold">Opening hours</p>
      <p>
        Open 7 days a week! <br/>
        Coffee/Pastries/Breakfast: 
        8am Mon to Fri, 9am Sat & Sun<br />
        Kitchen: 10:30 - 2:30 Mon to Wed, 10:30 - 3:00 Thurs - Sat,
        10-3 and 5-8pm Sun<br />
        Lunch: Mon to Sun <br />
        Dinner: 5pm Thurs - Sat* <br/>
      </p>
      <a
        href="https://www.instagram.com/elywinestore_maynooth/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-dark"
      >
        <i className="bi bi-instagram" style={{ fontSize: "1.5rem" }}></i>
      </a>
    </footer>
  );
}


